import { Flex, Text } from "@fluentui/react-northstar";
import React, { useEffect } from "react";
import AnnotationSystem from "../AnnotationSystem";
import { useIntelligentGrading } from "../../../../../../context/useIntelligentGrading";

const LinkAnalysis = ({ link, isAnnotationMode }) => {
  const { annotations, setAnnotations } = useIntelligentGrading();

  const index = annotations.findIndex(
    (annotation) => annotation.id === link.id
  );

  const onAnnotationAdd = (annotation) => {
    let clonedAnnotations = [...annotations];
    if (index === -1) {
      clonedAnnotations.push({ id: link.id, annotations: [annotation] });
    } else {
      clonedAnnotations[index].annotations.push(annotation);
    }
    setAnnotations(clonedAnnotations);
  };

  const onAnnotationDelete = (id) => {
    let clonedAnnotations = [...annotations];
    clonedAnnotations[index].annotations = clonedAnnotations[
      index
    ].annotations.filter((annotation) => annotation.id !== id);
    setAnnotations(clonedAnnotations);
  };
  const onAnnotationEdit = (id, comment) => {
    let clonedAnnotations = [...annotations];
    clonedAnnotations[index].annotations = clonedAnnotations[
      index
    ].annotations.map((annotation) =>
      annotation.id === id ? { ...annotation, comment } : annotation
    );
    setAnnotations(clonedAnnotations);
  };


  return (
    <Flex column gap="gap.small">
      <Text content="Link/URL Analysis" weight="semibold" />

      <div
        style={{
          background: "#fafbfc",
          border: "1px solid #e0e0e0",
          borderRadius: 8,
          padding: 16,
          marginBottom: 18,
        }}
      >
        <a
          href={link.info[0]}
          target="_blank"
          rel="noopener noreferrer"
          style={{
            color: "#3578e5",
            fontWeight: 500,
            fontSize: 16,
            textDecoration: "none",
            display: "flex",
            alignItems: "center",
            gap: 8,
          }}
        >
          <span role="img" aria-label="link" style={{ fontSize: 20 }}>
            🔗
          </span>
          <span style={{ wordBreak: "break-all" }}>{link.info[0]}</span>
        </a>
        {/* {context && (
        <div style={{ color: "#444", fontSize: 14, marginTop: 4 }}>
          Link submitted with context:{" "}
          <span style={{ fontStyle: "italic" }}>"{context}"</span>
        </div>
      )} */}
      </div>
      <Flex column gap="gap.small">
        <Text content="Link Content" weight="semibold" />

        <AnnotationSystem
          isAnnotationMode={isAnnotationMode}
          essayText={link.extractedText}
          annotations={annotations?.[index]?.annotations || []}
          onAnnotationAdd={onAnnotationAdd}
          onAnnotationDelete={onAnnotationDelete}
          onAnnotationEdit={onAnnotationEdit}
        />
      </Flex>
    </Flex>
  );
};

export default LinkAnalysis;
